import { User, UserAccess } from "../models";
import { RoleOptions } from "./constants";

export const privilegedUser = (user?: User): boolean => {
  return !!(user?.roles && (
    user.roles.includes(RoleOptions.administrator)
    || user.roles.includes(RoleOptions.instructor)
  ));
};

export const userAccess = (user: User): UserAccess => {
  return user && user.roles
    ? {
      privileged: user.roles.includes(RoleOptions.administrator) || user.roles.includes(RoleOptions.instructor),
      administrator: user.roles.includes(RoleOptions.administrator),
      instructor: user.roles.includes(RoleOptions.administrator) || user.roles.includes(RoleOptions.instructor),
      customer: user.roles.includes(RoleOptions.administrator) || user.roles.includes(RoleOptions.customer)
    }
    : {
      privileged: false,
      administrator: false,
      instructor: false,
      customer: false
    };
};